var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_1709)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1399_1709",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H60V60H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1399_1709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.099 11.3294C50.6345 12.7939 48.2601 12.7939 46.7956 11.3294C45.3311 9.86487 45.3311 7.49054 46.7956 6.02605C48.2601 4.56155 50.6345 4.56155 52.099 6.02605C53.5634 7.49054 53.5634 9.86487 52.099 11.3294Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2046 53.9739C11.7401 55.4384 9.36575 55.4384 7.90126 53.9739C6.43676 52.5094 6.43676 50.1351 7.90126 48.6706C9.36575 47.2061 11.7401 47.2061 13.2046 48.6706C14.6691 50.1351 14.6691 52.5094 13.2046 53.9739Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3146 58.2676C26.1526 58.6352 28.0536 58.8281 29.9997 58.8281C45.9211 58.8281 58.8279 45.9213 58.8279 30C58.8279 23.0497 56.3679 16.6743 52.2716 11.6958",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7398 1.74387C33.8849 1.3691 31.9655 1.17235 30 1.17235C14.0787 1.17235 1.17188 14.0791 1.17188 30.0005C1.17188 36.9507 3.63188 43.3262 7.72816 48.3047",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 38.5113C25.2994 38.5113 21.4887 34.7007 21.4887 30C21.4887 25.2994 25.2994 21.4888 30 21.4888C34.7007 21.4888 38.5114 25.2994 38.5114 30C38.5114 34.7007 34.7007 38.5113 30 38.5113ZM46.9729 26.3258C46.5264 24.2479 45.7088 22.3078 44.5916 20.5792L46.837 18.3337L41.6539 13.1544L39.4103 15.398C37.6817 14.2808 35.7418 13.4632 33.6638 13.0168V9.84375H26.3363V13.0168C24.2583 13.4632 22.3184 14.2808 20.5898 15.398L18.3462 13.1544L13.1631 18.3337L15.4084 20.5792C14.2913 22.3078 13.4737 24.2479 13.0272 26.3258H9.84578L9.8418 33.6532H13.0271C13.4736 35.7312 14.2912 37.6712 15.4083 39.4L13.1545 41.6538L18.3338 46.837L20.5895 44.5812C22.3183 45.6984 24.2583 46.5161 26.3363 46.9625V50.1562H33.6638V46.9625C35.7418 46.5161 37.6818 45.6984 39.4105 44.5812L41.6663 46.837L46.8456 41.6538L44.5918 39.4C45.7089 37.6712 46.5265 35.7312 46.973 33.6532H50.1583V26.3258H46.9729Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_1709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD1);
export default __webpack_public_path__ + "static/media/d1.15c2f4a7c7c889cd6f23c35ea3ef45b7.svg";
export { ForwardRef as ReactComponent };